import BadgeRequestContainer from "../../../Component/Application/myBadgeOrders/BadgeRequestContainer";

const MyBadgeOrderPage = () => {
    return (
        <div className="page-body">
            <BadgeRequestContainer />
        </div>
    );
};

export default MyBadgeOrderPage;
